






































import Vue from 'vue';

import SldsIcon from '../Icon/Icon.vue';

/**
 * Scoped notifications serve advisory information for the user that is not
 * important enough to justify an alert. It is often presented as a status bar
 * scoped to the container. They are not dismissible.
 *
 * @slot icon - Overrides the icon to be displayed.
 * @slot default - The notification content.
 */
export default Vue.extend({
  components: {
    SldsIcon,
  },
  props: {
    /**
     * The theme applied to the notification.
     */
    theme: {
      type: String,
      validator(val: string) {
        return ['info', 'success', 'warning', 'error'].includes(val);
      },
      default: undefined,
    },
    /**
     * The color variant applied to the notification.
     */
    variant: {
      type: String,
      validator(val: string) {
        return ['base', 'light', 'dark'].includes(val);
      },
      default: 'light',
    },
    bcWithFigure: {
      type: Boolean,
      default: true,
    },
  },
});
